import * as React from "react";
import { updateQueryParam } from "@grandvisionhq/utils";
import { OfferingsList } from "./OfferingsList.js";
const OfferingsListContainer = ({ offerings, selectedValue, onChange }) => {
  const handleOnChange = React.useCallback(
    (sku) => {
      const selectedOffering = offerings?.find((offering) => offering.sku === sku);
      if (!selectedOffering) return;
      onChange(selectedOffering);
      updateQueryParam("offerings", selectedOffering.title);
    },
    [offerings, onChange]
  );
  if (!offerings || !selectedValue.sku) return null;
  return /* @__PURE__ */ React.createElement(
    OfferingsList,
    {
      offeringItems: offerings,
      selectedValue: selectedValue.sku,
      onChange: handleOnChange,
      isCentAmount: false
    }
  );
};
export {
  OfferingsListContainer
};
//# sourceMappingURL=OfferingsListContainer.js.map
